// Perhitungan untuk mengarahkan kanvas ke kursi pelanggan.
//
// Dipakai bersama SeatMap dan SeatMapCircle. Sebelumnya rumus ini disalin di
// kedua berkas, dan salinannya sempat menghilangkan padY — akibatnya denah
// terlempar ke luar kanvas (layar hitam) karena galatnya ikut dikalikan scale.
// Dengan satu sumber, keduanya tidak bisa lagi berbeda.

// Seberapa besar kursi pelanggan boleh memenuhi kanvas saat denah dibuka.
const WIDTH_RATIO = 0.55;
const HEIGHT_RATIO = 0.45;
const MIN_SCALE = 1;
const MAX_SCALE = 8;

export const IDENTITY_TRANSFORM = { scale: 1, translateX: 0, translateY: 0 };

/**
 * @param viewBox {{x,y,w,h}} viewBox SVG dalam satuan pengguna
 * @param box     {{width,height}} ukuran kanvas dalam piksel
 * @param rects   Array<{x,y}> posisi kursi pelanggan dalam satuan viewBox
 * @param seatSize ukuran satu kursi dalam satuan viewBox
 * @returns transform, atau null kalau datanya belum cukup
 */
export const fitToSeats = ({ viewBox, box, rects, seatSize }) => {
  if (!viewBox?.w || !viewBox?.h) return null;
  if (!box?.width || !box?.height) return null;
  if (!rects?.length) return null;

  // preserveAspectRatio="xMidYMid meet": diskalakan seragam, lalu sisa ruang
  // dibagi rata di kedua sisi — pada kedua sumbu, bukan hanya horizontal.
  const unit = Math.min(box.width / viewBox.w, box.height / viewBox.h);
  const padX = (box.width - viewBox.w * unit) / 2;
  const padY = (box.height - viewBox.h * unit) / 2;

  const xs = rects.map((r) => r.x);
  const ys = rects.map((r) => r.y);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  const spanX = (maxX - minX + seatSize) * unit;
  const spanY = (maxY - minY + seatSize) * unit;
  const centerX = padX + ((minX + maxX + seatSize) / 2 - viewBox.x) * unit;
  const centerY = padY + ((minY + maxY + seatSize) / 2 - viewBox.y) * unit;

  const scale = Math.min(
    MAX_SCALE,
    Math.max(
      MIN_SCALE,
      Math.min(
        (box.width * WIDTH_RATIO) / spanX,
        (box.height * HEIGHT_RATIO) / spanY,
      ),
    ),
  );

  // transform-origin '0 0', jadi titik c berpindah ke (translate + scale*c).
  return {
    scale,
    translateX: box.width / 2 - scale * centerX,
    translateY: box.height / 2 - scale * centerY,
  };
};
